import firebase from 'firebase';

export default {
  state: {
    isLoggedIn: undefined
  },
  effects: (dispatch) => ({
    async authListener(payload, rootState) {
      firebase.auth().onAuthStateChanged((firebaseUser) => {
        dispatch.auth.authListenerResult(firebaseUser !== null);
      });
    },
    async login({ email, password }, rootState) {
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then((userCredentials) => {
          console.log({ userCredentials });
          dispatch.auth.loginResult(userCredentials);
        });
    },
    async logout(payload, rootState) {
      await firebase.auth().signOut();
      dispatch.auth.logoutResult();
    },
    async fetchProfile() {
      const userSnap = await firebase
        .database()
        .ref(`users/${firebase.auth().currentUser.uid}`)
        .once('value');
      dispatch.auth.genericReducer({ profile: userSnap.val() });
    }
  }),
  reducers: {
    genericReducer(state, payload) {
      return {
        ...state,
        ...payload
      };
    },
    authListenerResult(state, isLoggedIn) {
      return {
        ...state,
        isLoggedIn
      };
    },
    loginResult(state, userCredentials) {
      return {
        ...state,
        userCredentials
      };
    },
    logoutResult(state, payload) {
      return {
        isLoggedIn: false
      };
    }
  }
};
